module.exports = __webpack_public_path__ + "static/media/Bosyapp-dialog.40d42cb8.jpg";